import React from 'react';
import moment from 'moment';
import { Divider, Icon } from 'antd';
import { splitEvery, isEmpty } from 'ramda';
import Context from '../Container/Context';
import BroadcastAnchor from './BroadcastAnchor';
import { asserts, auth } from '../../../utils';
import './Broadcast.less';

const { showAuthModal } = auth;

/**
 * 用来拆分成可以轮播的广播数据，顺便内部处理"鼠标悬浮时暂停滚动"
 */
const useBroadcastList = () => {
  const { basicConfig } = React.useContext(Context);
  const { newsList = [], annRollInter = 3000 } = basicConfig;

  const [broad, setBroad] = React.useState(() => newsList.slice(0, 2));
  const [isHover, setIsHover] = React.useState(false);

  const mouseEnter = () => setIsHover(true);
  const mouseLeave = () => setIsHover(false);

  React.useEffect(() => {
    const target = document.getElementById('js-broadcast');
    target.addEventListener('mouseover', mouseEnter);
    target.addEventListener('mouseout', mouseLeave);
    return () => {
      target.removeEventListener('mouseover', mouseEnter);
      target.removeEventListener('mouseout', mouseLeave);
    };
  });

  React.useEffect(() => {
    let count = 0;
    let timer;
    const modifiedBroadcast = splitEvery(2, newsList);
    const addTimer = () => {
      timer = setInterval(() => {
        const next = count + 1 === modifiedBroadcast.length ? 0 : count + 1;
        const newBroadcast = modifiedBroadcast[next] || [];
        count = next;
        setBroad(newBroadcast);
      }, annRollInter);
    };
    const removeTimer = () => {
      timer && clearInterval(timer);
    };
    isHover ? removeTimer() : addTimer();
    return () => {
      count = 0;
      removeTimer();
    };
  }, [newsList, annRollInter, isHover]);

  return broad;
};

const getJudgementPath = (item, isMore) => {
  const { queryArtiAboutParent = [] } = item;
  let newLocation = null;
  if (queryArtiAboutParent && queryArtiAboutParent.length === 1) {
    const [parentItem = {}] = queryArtiAboutParent;
    if (isMore) {
      newLocation = `/notification/${parentItem.acCode}?acId=${parentItem.acId}`;
    } else {
      newLocation = `/notification/${parentItem.acCode}/detail?acId=${parentItem.acId}&adId=${item.adId}`;
    }
  } else if (queryArtiAboutParent && queryArtiAboutParent.length === 2) {
    queryArtiAboutParent.forEach((info) => {
      if (`${info.acLevel}` === '2') {
        if (isMore) {
          newLocation = `/notification/${info.pacCode}/${info.acCode}?acId=${info.acId}`;
        } else {
          newLocation = `/notification/${info.pacCode}/${info.acCode}/detail?acId=${info.acId}&adId=${item.adId}`;
        }
      }
    });
  }
  return newLocation;
};

export default () => {
  const isTopBroadcast = window.tmConfig.isTopBroadcast();
  if (!isTopBroadcast) return <BroadcastAnchor />;
  const { principal, history } = React.useContext(Context);
  const isLoginIn = asserts.isExist(principal);

  const broad = useBroadcastList();

  const handleRouter = (item, isMore) => {
    if (!isLoginIn) {
      showAuthModal();
    } else {
      if (!asserts.isExist(item)) return;
      const jumpPath = getJudgementPath(item, isMore);
      jumpPath && history.replace(jumpPath);
    }
  };

  // 占位，防止头部抖动
  return isEmpty(broad) ? (
    <BroadcastAnchor id="js-broadcast" />
  ) : (
    <section id="js-broadcast" className="carousel-broadcast-top">
      {broad.map((item, index) => (
        <div key={index} className="broadcast-wrapper" style={{ paddingRight: isLoginIn ? 84 : 0 }}>
          <div className="broadcast-main pointer" onClick={() => handleRouter(item, false)}>
            <Icon type="notification" />
            <span className="title-left">{item && item.adTitle}</span>
            {item && `${item.dateStatus}` === '0' && (
              <time className="float-right">
                {!!item.releaseDate && moment(item.releaseDate).format('YYYY-MM-DD')}
              </time>
            )}
          </div>

          {isLoginIn ? (
            <div className="broadcast-right align-right">
              {item && `${item.dateStatus}` === '0' && <Divider type="vertical" />}
              <span className="broadcast-separate pointer" onClick={() => handleRouter(item, true)}>
                更多
              </span>
              <Icon type="right" />
            </div>
          ) : null}
        </div>
      ))}
    </section>
  );
};
